import { PageMetadata } from '../../classes/paged-results';
import { AbstractPaginator } from './abstract-paginator';

export class ServerPaginator extends AbstractPaginator {
  public pages: number;
  public numberElements: number;

  public update(metadata: PageMetadata) {
    this.pages = metadata.totalPages;
    this.numberElements = metadata.totalResults;
  }

  public reset(): void {
    this.page = 0;
  }
}
